import { logger } from "@origin-digital/reporting-client";
import { xhrFetch } from "@origin-digital/daxi";
import * as Cookies from "js-cookie";
import { formatQueryParameters } from "../helpers/url.helper";

interface IVisitorTokenResponse {
  visitorToken: string;
}

interface IVisitorRequestParams {
  internal: boolean;
  url: string;
  visitorToken?: string;
}

const path = "/api/v1/visitorToken";
const VISITOR_COOKIE_NAME = "bc.visitor_token";

export const fetchVisitorToken = async (
  host: string
): Promise<string | undefined> => {
  try {
    const params: IVisitorRequestParams = {
      internal: true,
      url: window.location.href,
    };
    const cookie = Cookies.get(VISITOR_COOKIE_NAME);
    if (cookie) {
      params.visitorToken = cookie;
    }
    const { data } = await xhrFetch<IVisitorTokenResponse>(
      `${host}${path}?${formatQueryParameters(params)}`,
      { includeCommonHeaders: false }
    );
    if (data) {
      const { visitorToken } = data;
      const in10Years = new Date(
        Date.now() + 1000 * 60 * 60 * 24 * 365.25 * 10
      );
      Cookies.set(VISITOR_COOKIE_NAME, visitorToken, { expires: in10Years });
      return data && data.visitorToken;
    }
  } catch (error) {
    logger.error("error fetching visitorToken", error);
  }
  return undefined;
};
